import React from 'react'
import { AdminCompanyInvoices } from '..'

const AdminInvoices = () => {
    return <AdminCompanyInvoices />
}

export default AdminInvoices
